import { Avatar, Box, Chip, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const tHost = "Host";

export interface HistoryItemCardProps {
  id: string;
  name: string;
  description?: string;
  ownerFirstName?: string;
  ownerLastName?: string;
  avatarUrl: string;
  linkTo: string;
  type?: "Room" | "Event";
  showChips?: boolean;
}

export const HistoryItemCard = ({
  id,
  name,
  description,
  ownerFirstName,
  ownerLastName,
  avatarUrl,
  linkTo,
  type,
  showChips = true,
}: HistoryItemCardProps) => {
  return (
    <Link key={id} style={{ color: "inherit", textDecoration: "none", width: "100%" }} to={linkTo}>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.background.paper,
          borderRadius: 2,
          boxShadow: 2,
          boxSizing: "border-box",
          display: "grid",
          gap: 1.5,
          gridTemplateColumns: "auto minmax(0, 1fr)",
          minWidth: 0,
          p: 1.5,
          width: "100%",
        }}
      >
        <Avatar
          alt={name ?? "Organization"}
          src={avatarUrl}
          sx={{
            height: { md: 64, sm: 48, xs: 40 },
            width: { md: 64, sm: 48, xs: 40 },
          }}
        />
        <Box sx={{ minWidth: 0, overflow: "hidden" }}>
          <Box sx={{ alignItems: "center", display: "flex", gap: 1, mb: type && showChips ? 0.5 : 0, minWidth: 0 }}>
            <Typography
              component="h3"
              sx={{
                flexGrow: 1,
                fontWeight: "medium",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              variant="h6"
            >
              {name}
            </Typography>
            {type && showChips && (
              <Chip
                label={type}
                size="small"
                color={type === "Room" ? "primary" : "secondary"}
                sx={{ flexShrink: 0 }}
              />
            )}
          </Box>
          {(ownerFirstName || ownerLastName) && (
            <Typography
              color="text.secondary"
              sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
              variant="body2"
            >
              {tHost}: {ownerFirstName} {ownerLastName}
            </Typography>
          )}
          {description && (
            <Typography
              color="text.secondary"
              sx={{
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                display: "-webkit-box",
                mt: 0.5,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              variant="body2"
            >
              {description}
            </Typography>
          )}
        </Box>
      </Box>
    </Link>
  );
};
